import { PageContext } from '@websrc/App/AppContext'
import { AppProvider } from '@websrc/App/AppProvider'
import { pathToPageName } from '@websrc/App/Helpers/pathToPageName'
import React from 'react'

import { UnitPlan, UnitPlanProps } from './UnitPlan'

export interface UnitPlanPageProps {
  pageContext: PageContext & {
    unitPlan: UnitPlanProps
  }
}

export default function UnitPlanPage({ pageContext }: UnitPlanPageProps) {
  const { appContext, unitPlan } = pageContext
  const [siteSection, pageName] = pathToPageName(appContext.path)
  const pageType = 'unit-plan'

  return (
    <AppProvider
      {...appContext}
      matomoPageTemplate={'unit_plan_overviews'}
      pageName={pageName}
      pageType={pageType}
      siteSection={siteSection}
    >
      <UnitPlan {...unitPlan} />
    </AppProvider>
  )
}
